import React from "react";
import "./Meaning.css";
import "bootstrap/dist/css/bootstrap.css";

export default function Meaning(props) {
  return (
    <div className="Meaning">
      <h3 className="text-capitalize">{props.meaning.partOfSpeech}</h3>
      {props.meaning.definitions.map(function (definition, index) {
        return (
          <div key={index}>
            <div className="definition ">{definition.definition}</div>
            <div className="example">
              <em>{definition.example}</em>
            </div>
          </div>
        );
      })}
      <span className="synonyms fw-bold">Synonyms: </span>
      {props.meaning.synonyms.map(function (synonym, index) {
        return (
          <span key={index} className="synonyms">
            {synonym},
          </span>
        );
      })}
      <span>...</span>
      <br />
      <br />
      <br />
    </div>
  );
}
